import gql from 'graphql-tag'

export const PAGE_QUERY = gql`
  query PaidySMReservationRequestView($roomId: Int!, $rentType: RentType!) {
    room(id: $roomId, rentType: $rentType) {
      id
      owner {
        contactName
        contactNameKana
        numberOfDaysFromRegister
        completeReservationCountExceptPaidy
      }
      space {
        postalCodeText
        stateText
        city
        address1
        address2
        spaceTypeText
      }
    }
    viewer {
      id
      numberOfDaysFromRegister
      completeReservationCountExceptPaidy
      completeLastReservationPayAmountExceptPaidy
      ltvExceptPaidy
      dayOfLastCompleteReservationExceptPaidy
      email
      contactName
      verifiedTel
    }
  }
`



// WEBPACK FOOTER //
// ./src/containers/organisms/PaidyCharge/graphql.js